import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

export const SignIn = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const restorePathname = localStorage.getItem('signin-restore-pathname');
    console.log('restore path name:', restorePathname);

    if (restorePathname) {
      localStorage.removeItem('signin-restore-pathname');
      // Parse the pathname and search params for TanStack Router
      const [path, search] = restorePathname.split('?');
      const searchParams = search
        ? Object.fromEntries(new URLSearchParams(search).entries())
        : undefined;
      navigate({ to: path, search: searchParams });
    } else {
      navigate({ to: '/' });
    }
  }, []);

  return <></>;
};
